import {RouteComponentProps, useParams} from "react-router";
import {useRequest} from "ahooks";
import * as api from "../../apis/sampleCalcProportion";
import {Fragment, useEffect, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {useForm, useWatch} from "antd/lib/form/Form";
import {Button, Card, Form, InputNumber, message, Space, Table} from "antd";
import {ColumnProps} from "antd/lib/table";
import styles from "./index.module.css";
import ProductSelectModal from "../../components/ProductSelectModal";
import * as sampleApi from "../../apis/sample";
import * as productApi from "../../apis/product";

import {useHistory} from "react-router-dom";
import withAuth from "../../utils/withAuth";


type RouteParams = {
    id: string
};

const EditFragment = withAuth('edit', Fragment);
const StatusFragment = withAuth('status', Fragment);

function SampleCalcProportionDetail(props: RouteComponentProps<RouteParams>) {
    const id = useParams<RouteParams>().id;
    const history = useHistory();
    const [form] = useForm();
    const [enableEdit, setEnableEdit] = useState(false);
    const [record, setRecord] = useState<any>({});
    const [productSelectModalVisible, setProductSelectModalVisible] = useState(false);
    const formList: Array<any> = useWatch('list', form);

    useEffect(() => {
        if (id) {
            runGetData(id)
        }
    }, [])

    const {run: runGetData} = useRequest(api.getReagentDetail, {
        manual: true,
        onSuccess: (response) => {
            setRecord(response.data.data)
            form.setFieldsValue({list: [...response.data.data.list]});
        }
    });


    const {loading: loadingSave, run: runSave} = useRequest(api.submitReagentProportion, {
        manual: true,
        onSuccess(res) {
            message.success('修改成功');
            runGetData(id);
            setEnableEdit(false);
        }
    })

    const {run: switchStatus} = useRequest(api.switchStatus, {
        manual: true,
        onSuccess(res) {
            message.success('成功');
            runGetData(id);
        }
    })

    const handleProductSelected = (keys?: Array<number>, records?: Array<any>) => {
        if (!!records?.length) {
            const result = records.map(item => ({
                productCode: item.code,
                productName: item.name,
                id: undefined
            }));
            form.setFieldValue('list', [...formList, ...result]);
        }
        setProductSelectModalVisible(false);
    }
    const handleRemove = (index: number) => {
        form.setFieldValue('list', formList.filter((_: any, i: number) => i != index));
    }
    const handleAdd = () => {
        setProductSelectModalVisible(true);
    }

    const handleCancelEdit = () => {
        form.setFieldsValue({list: [...record.list]});
        setEnableEdit(false);
    }
    const handleSaveEdit = () => {
        if (formList.some(item => !item.proportion)) {
            message.error('请设置比例');
            return;
        }
        runSave({reagentId: id, list: formList});
    }


    const columns: Array<ColumnProps<any>> = [
        {
            dataIndex: 'operation',
            key: 'operation',
            title: '操作',
            render(v, r, i) {
                return <Space>
                    <Button onClick={() => handleRemove(i)}>-</Button>
                    <Button onClick={handleAdd}>+</Button>
                </Space>
            }
        },
        {
            dataIndex: 'productCode',
            key: 'productCode',
            title: '商品编号'
        },
        {
            dataIndex: 'productName',
            key: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'proportion',
            key: 'proportion',
            title: '比例',
            render(v, r, i) {
                return (
                    <Form.Item name={[i, 'proportion']}>
                        <InputNumber step={0.1} min={0.1} max={1}/>
                    </Form.Item>
                )
            }
        }
    ];

    const toolbar = (
        <Space className={styles.Toolbar}>
            <EditFragment><Button type={"link"} loading={loadingSave} onClick={() => setEnableEdit(true)}>修改</Button></EditFragment>
            <StatusFragment><Button type={"link"} loading={loadingSave}
                                    onClick={() => switchStatus(id)}>{record.status ? '停用' : '启用'}</Button></StatusFragment>
            <Button type={"link"} onClick={() => enableEdit ? setEnableEdit(false) : history.goBack()}>返回</Button>
        </Space>
    );

    return <PageHeaderLayout onOk={handleSaveEdit} onCancel={handleCancelEdit} withFooterBar={enableEdit}>
        <Card title={toolbar} className={styles.Content}>
            <Form disabled={!enableEdit} form={form}>
                <Form.List name={'list'}>
                    {fields => (
                        <Table columns={columns}
                               pagination={false}
                               dataSource={formList?.length ? form.getFieldValue('list') : [{}]}/>
                    )}
                </Form.List>
            </Form>
        </Card>

        {productSelectModalVisible && <ProductSelectModal multiple open={productSelectModalVisible}
                                                          onCancel={() => setProductSelectModalVisible(false)}
                                                          onComplete={handleProductSelected}
                                                          url={productApi.getAllProductsUrl}
                                                          // queryParams={{placeOrder: 10}}
        />}

    </PageHeaderLayout>
}

export default SampleCalcProportionDetail
